import React from 'react';
import { DrawStatus } from 'constants/enums/drawStatus.enum';
import commonService from 'utils/commonService';
import BgImage from 'components/BgImage';
import DotPagination from 'components/DotPagination';
import { IProps } from './types';

const Page: React.FC<IProps> = (props) => {
  return (
    <>
      {/* 當頁抽獎活動 */}
      <div className={'list' + (props.items.length === 0 ? ' empty' : '')}>
        {props.items.map((it, index) => (
          <button type="button" className={'card' + (it.DRAW_STATUS === DrawStatus.D ? '' : ' closed')} key={`game-pc-${index}`} title={it.TITLE} onClick={() => props.onItemClick(it)}>
            <h2 className="title">{it.TITLE}</h2>
            <div className="poster">
              <BgImage className="img" keepRatio imageUrl={commonService.convertImageUrl(it.IMAGE_NAME)} />
            </div>
            <div className="status">
              {/* 可抽獎次數：
              <span className="emphsis">{it.DRAW_CNT}</span> 次 */}
              {props.displayMsg(it.SN, it.STATUS_MSG, false)}
            </div>
          </button>
        ))}
      </div>
      {/* 顯示分頁按鈕 */}
      {props.totalCount > 0 && (
        <div className="listPagination">
          <DotPagination
            totalCount={props.totalCount}
            pageSize={props.pageSize}
            onChange={(pageIndex: number) => {
              props.onPageChange(pageIndex);
            }}
          />
        </div>
      )}
    </>
  );
};

export default Page;
